import React, { useState } from 'react'
import s from './accordion.module.css'
import { ArrowTriangleDown } from '../../svg/arrow_triangle_down'
import { ArrowTriangleUp } from '../../svg/arrow_triangle_up'
import { GTMEvents } from '../../lib/GTMevents'

const ButtonOpen = ({ p }) =>
  p.icoOpen ? (
    <p.icoOpen fill={p.icoColor} />
  ) : (
    <ArrowTriangleUp fill={p.icoColor} />
  )

const ButtonClose = ({ p }) =>
  p.icoClose ? (
    <p.icoClose fill={p.icoColor} />
  ) : (
    <ArrowTriangleDown fill={p.icoColor} />
  )

const Accordion = props => {
  const [isActive, setIsActive] = useState(false)
  return (
    <div onClick={ props.ATM ? (e)=> { e.preventDefault(); GTMEvents.TypeContributionAccordion(props.GTMSection, props.GTMSubSection,props.GTMtype.length > 0 ?`${props.GTMtype} | ${ props.title}`: props.title, props.GTMLink)} : ()=>GTMEvents.TypeContributionQuestionsYape(props.GTMSection, props.GTMSubSection,props.GTMtype.length > 0 ?`${props.GTMtype} | ${ props.title}`: props.title, props.GTMLink)} id='GTM-MOD-MEP-SECTION-TP-ACCORDION' className={`${s.accordionItem} ${props.className}`}>
      <div
        id='GTM-MOD-MEP-SECTION-TP-ACCORDION-CONTAINER'
        className={props.borderBottom? `${s.accordionHeaderBorderBottom}` : `${s.accordionHeader}`}
        onClick={() => setIsActive(!isActive)}
      >
        <div id='GTM-MOD-MEP-SECTION-TP-ACCORDION-ITEM' className={`${s.accordionTitle} ${isActive && props.titleColorOpen && s.accordionTitleOpen}`}>{props.title}</div>
        <div className={`${s.accordionButton}`}>
          {isActive ? <ButtonOpen p={props} /> : <ButtonClose p={props} />}
        </div>
      </div>
      {isActive && (
        <div className={props.borderBottom? `${s.accordionContentBorderBottom}` : `${s.accordionContent}`}>{props.content}</div>
      )}
    </div>
  )
}

Accordion.defaultProps = {
  title: '', // Titulo del tab
  content: '', // Contenido del tab
  icoClose: '', // Muestra icono flecha vertical hacia abajo (Cerrado)
  icoOpen: '', // Muestra icono flecha vertical hacia arriba (Abierto)
  icoColor: '#FF4F00', // Color del icono
  className: '', // Clase CSS
  titleColorOpen: '', // Color del titulo cuando se abre la opcion
  borderBottom: '', // Agregar o quitar borde
  GTMSection:'',
  GTMSubSection:'',
  GTMLink:'',
  GTMtype:'',
  ATM: false,
}

export default Accordion
